import type { WordCloudData } from '@mentimeter/visualizations';

interface ScreenReaderResultsProps {
  results: WordCloudData[];
  shouldHideResults: boolean;
}

export const ScreenReaderResults = ({
  results,
  shouldHideResults,
}: ScreenReaderResultsProps) => {
  if (shouldHideResults) {
    return <span>Results are currently hidden.</span>;
  }

  return (
    <table lang="en">
      <caption>Results</caption>
      <thead>
        <tr>
          <th>Word</th>
          <th>Number of occurances</th>
        </tr>
      </thead>
      <tbody>
        {results.map((response) => (
          <tr key={response.key}>
            <td>{response.text}</td>
            <td>{response.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
